import { render, staticRenderFns } from "./SecretVertify.vue?vue&type=template&id=5da30d00&scoped=true"
import script from "./SecretVertify.vue?vue&type=script&lang=js"
export * from "./SecretVertify.vue?vue&type=script&lang=js"
import style0 from "./SecretVertify.vue?vue&type=style&index=0&id=5da30d00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da30d00",
  null
  
)

export default component.exports